/**
 * Build a full redirect URL for mini-program login.
 *
 * This project uses hash routing, so the safest redirect is:
 *   https://domain/#/path?query
 *
 * In some mini-program webview scenarios, window.location.href may degrade to:
 *   /entry-page/xxx?...
 * or even be empty. This helper normalizes those cases.
 */
export function buildFullHashRedirectUrl(inputPath) {
  const origin = window.location.origin || ''
  const href = window.location.href || ''
  const hashPath = (window.location.hash || '').replace(/^#/, '') // "/entry-page/xxx?..."

  // explicit inputPath preferred (e.g. "/entry-page/xxx?..." or "#/entry-page/xxx?...")
  const raw = (inputPath || '').toString()

  if (/^https?:\/\//i.test(raw)) return raw
  if (/^https?:\/\//i.test(href)) return href

  const cleaned = raw.replace(/^#/, '') // "/entry-page/..." if raw was "#/entry-page/..."
  if (origin && cleaned && cleaned[0] === '/') return origin + '/#' + cleaned
  if (origin && hashPath) return origin + '/#' + hashPath
  if (origin && href && href[0] === '/') return origin + '/#' + href
  if (origin) return origin + '/'

  // last resort fallback (may still be relative, but better than empty)
  return cleaned || (hashPath ? ('/#' + hashPath) : href)
}

